import { useState } from 'react';
export var useReactive = function (name, initialValue) {
    var _a = useState(initialValue), state = _a[0], setState = _a[1];
    var onChange = function (value, cb) {
        setState(value);
        cb === null || cb === void 0 ? void 0 : cb(name, value);
    };
    return [state, onChange];
};
